const Lang = ({ children }) => {
  return <> {children}</>;
};
export default Lang;
